import React from 'react';
import {
  SimpleGrid,
  Box,
  Image,
  Text,
  Button,
  VStack,
  Heading,
  useColorModeValue,
  Badge,
} from '@chakra-ui/react';

const templates = [
  // { cssTemplateId: 'MKTEXITINTENTTEMP0', name: 'Single Button', imgSrc: '/images/exitintent-template/1.jpg', type: 'Basic' },
  { cssTemplateId: 'MKTEXITINTENTTEMP1', name: 'Single Button', imgSrc: '/images/exitintent-template/2.jpg', type: 'Basic' },
  { cssTemplateId: 'MKTEXITINTENTTEMP2', name: 'Fullscreen 1', imgSrc: '/images/exitintent-template/3.jpg', type: 'Fullscreen' },
  { cssTemplateId: 'MKTEXITINTENTTEMP3', name: 'Two Buttons', imgSrc: '/images/exitintent-template/4.jpg', type: 'Advanced' },
  { cssTemplateId: 'MKTEXITINTENTTEMP4', name: 'Two Buttons', imgSrc: '/images/exitintent-template/5.jpg', type: 'Advanced' },
  // { cssTemplateId: 'MKTEXITINTENTTEMP31', imgSrc: '/images/exitintent-template/gemification-for-desktop.png',name: 'Spin the wheel (Desktop)',type: "Advanced"},

  // { cssTemplateId: 'MKTEXITINTENTTEMP5', name: 'Single Button', imgSrc: '/images/exitintent-template/6.jpg', type: 'Basic' },
  // { cssTemplateId: 'MKTEXITINTENTTEMP6', name: 'Two Buttons', imgSrc: '/images/exitintent-template/7.jpg', type: 'Advanced' },
  // { cssTemplateId: 'MKTEXITINTENTTEMP7', name: 'Fullscreen 2', imgSrc: '/images/exitintent-template/8.jpg', type: 'Fullscreen' },
  // { cssTemplateId: 'MKTEXITINTENTTEMP8', name: 'Two-Step Banner', imgSrc: '/images/exitintent-template/9.jpg', type: 'Advanced' },
  // { cssTemplateId: 'MKTEXITINTENTTEMP9', name: 'Mobile Template 1', imgSrc: '/images/exitintent-template/10.jpg', type: 'Mobile' },
  // { cssTemplateId: 'MKTEXITINTENTTEMP10', name: 'Two-Step', imgSrc: '/images/exitintent-template/11.jpg', type: 'Advanced' },
  // { cssTemplateId: 'MKTEXITINTENTTEMP18', name: 'Mobile Template 2', imgSrc: '/images/exitintent-template/18.jpg', type: 'Mobile' },
];

const TemplateSelection = ({ onTemplateSelect }) => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const hoverBgColor = useColorModeValue('gray.100', 'gray.700');
  const badgeColorScheme = useColorModeValue('blue', 'cyan');

  return (
    <VStack spacing={6} align="stretch">
      <Heading size="lg" textAlign="center" mb={4}>
        {/* Choose Your Exit Intent Template */}
      </Heading>
      <SimpleGrid 
        columns={{ base: 1, sm: 2, md: 3, lg: 4 }} 
        spacing={6}
        px={4}
      >
        {templates.map((template) => (
          <Box
            key={template.cssTemplateId}
            bg={bgColor}
            borderWidth="1px"
            borderRadius="lg"
            overflow="hidden"
            transition="all 0.2s"
            _hover={{
              transform: 'translateY(-5px)',
              boxShadow: 'lg',
              bg: hoverBgColor,
            }}
            p={4}
          >
            <Image
              src={template.imgSrc}
              alt={template.name}
              height="200px"
              width="100%"
              objectFit="cover"
              borderRadius="md"
              mb={4}
            />
            <VStack spacing={3} align="stretch">
              <Box>
                <Text fontWeight="bold" fontSize="lg">
                  {template.name}
                </Text>
                <Badge 
                  colorScheme={badgeColorScheme} 
                  variant="subtle" 
                  mt={1}
                >
                  {template.type}
                </Badge>
              </Box>
              <Button
                onClick={() => onTemplateSelect?.(template.cssTemplateId)}
                colorScheme="blue"
                size="md"
                variant="solid"
                _hover={{ bg: 'blue.600' }}
              >
                Select Template
              </Button>
            </VStack>
          </Box>
        ))}
      </SimpleGrid>
    </VStack>
  );
};

export default TemplateSelection;